import PropTypes from 'prop-types';
import { values } from 'ramda';

export const EXPERTISE = {
  AUDIOVISUAL: 'audiovisual',
  BANK_INSURANCE: 'bank',
  COURRIER: 'courrier',
  DIGITAL: 'digital',
  ENERGY: 'energy',
  HUMAN_RESOURCES: 'human-resource',
  INTERNATIONAL: 'international',
  MOBILE: 'mobile',
  PARTNERS: 'partner',
  TRANSVERSE: 'transverse',
  URBAN: 'urban',
};

export const ExpertiseType = PropTypes.oneOf(values(EXPERTISE));
